<template>
    <div>
        <div class="modal hide fade" id="modalAdjustForm" tabindex="-1" role="dialog" aria-labelledby="modalAdjustForm" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Adjust
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-6">
                          <dl class="row dl-custom font-12">
                            <dt class="col-md-5">Date</dt>
                            <dd class="col-md-7">
                              <!-- <input type="text" class="form-control" v-model="inventory.inventory_date"> -->
                              <datetime v-model="inventory.inventory_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local"></datetime>
                            </dd>
                            <dt class="col-md-5">Type</dt>
                            <dd class="col-md-7">
                              <select v-model="inventory.type_id" class="form-control">
                                <option v-for="t in itList" :key="t.id" :value="t.id">{{ t.name }}</option>
                              </select>
                            </dd>
                          </dl>
                        </div>
                        <div class="col-md-6">
                          <dl class="row dl-custom">
                            <dt class="col-md-5">Company</dt>
                            <dd class="col-md-7">
                              <select class="form-control" v-model="inventory.company_no">
                                <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                              </select>
                            </dd>
                            <dt class="col-md-5">Warehouse</dt>
                            <dd class="col-md-7">
                              <select v-model="inventory.warehouse_no" id="warehouse_no" class="form-control form-control-lite">
                                <option value="">---</option>
                                <option v-for="w in warehouseList" :key="w.id" :value="w.warehouse_no"><b>[{{ w.warehouse_no }}]</b> {{ w.name }}</option>
                              </select>
                            </dd>
                            <dt class="col-md-5">Vendor No.</dt>
                            <dd class="col-md-7">
                              <v-select class="vsc-custom" :options="vendorSelect" :reduce="vendor => vendor.meta.code" label="vendor" v-model="inventory.vendor_no"/>
                            </dd>
                            <dt class="col-md-5">Notes:</dt>
                            <dd class="col-md-7">
                              <textarea rows="3" class="form-control" v-model="inventory.notes"></textarea>
                            </dd>
                          </dl>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <ul class="nav nav-tabs nav-bordered">
                            <li class="nav-item">
                              <a href="#general" data-toggle="tab" aria-expanded="false" class="nav-link active">
                                Data
                              </a>
                            </li>
                          </ul>
                          <div class="tab-content">
                            <div class="tab-pane active" id="general">
                              <div class="table-responsive">
                                <table class="table table-sm table-item table-striped">
                                  <thead>
                                    <th>Product No.</th>
                                    <th>Qty</th>
                                    <th>UoM</th>
                                    <th>Harga</th>
                                    <!-- <th>Serial Number</th>
                                    <th>Serial Number 2</th> -->
                                    <th>Vendor</th>
                                    <th>#</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(p, index) in inventory.details" :key="p.id">
                                      <td>
                                        <v-select :options="productselect" :reduce="product => product.meta.code" label="product" v-model="p.product_no" @input="setProduct(index)"/>
                                      </td>
                                      <!-- <td><b>{{ p.product_sku }}</b></td> -->
                                      <!-- <td><input type="text" v-model="p.product" class="form-control" disabled="disabled"></td> -->
                                      <td><input type="text" v-model="p.qty_done" class="form-control"/></td>
                                      <td>
                                        <select v-model="p.uom_id" class="form-control" @input="setUom(index, p.uom_id, $event)">
                                          <option v-for="u in p.uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                                        </select>
                                      </td>
                                      <td><input type="text" v-model="p.cost" class="form-control" v-money="money"/></td>
                                      <!-- <td><input type="text" v-model="p.serial_number" class="form-control"/></td>
                                      <td><input type="text" v-model="p.sec_serial_number" class="form-control"/></td> -->
                                      <td>
                                        <v-select class="vsc-custom" :options="vendorSelect" :reduce="vendor => vendor.meta.code" label="vendor" v-model="p.vendor_no"/>
                                      </td>
                                      <td>
                                        <button type="button" class="btn btn-sm btn-soft-outline-danger" @click="remove(index)">
                                          <i class="fa fa-trash"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-soft-outline-primary" @click="setProduct(index)">
                                          <i class="fa fa-refresh"></i>
                                        </button>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <span @click="addLine" class="link-secondary">Add Line</span>
                                      </td>
                                      <td>
                                        {{ totalDetailQtyDone }}
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <!-- <td></td> -->
                                      <td></td>
                                      <td>
                                        <h5>Total: {{ totalDetailCount }}</h5>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-success" data-dismiss="modal" @click="saveInventory">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapState } from 'vuex'
import { inventoryUrl, productUrl, getHeader } from '@/config'

export default {
  name: 'AdjustFormModal',
  props: ['date', 'proNo'],
  components: {
    //
  },
  created () {
    // Add barcode scan listener and pass the callback function
    console.log('created')
  },
  mounted () {
    this.$barcodeScanner.init(this.onBarcodeScanned)
  },
  destroyed () {
    // Remove listener when component is destroyed
    this.$barcodeScanner.destroy()
  },
  data () {
    return {
      inventory: {
        id: null,
        inventory_no: null,
        type_id: null,
        inventory_date: this.date,
        purchasing_no: null,
        purchasing_id: null,
        warehouse_no: null,
        total_detail: null,
        status: null,
        ext_no: null,
        branch_no: null,
        user_id: null,
        user_approve: null,
        lock: false,
        ext_no2: null,
        vendor_no: null,
        details: []
      },
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      searchQueryPurchasing: '',
      card1: 'col-md-12',
      card2: 'col-md-4',
      selected: [],
      selectAll: null,
      idDetail: null,
      idPDetail: null,
      product: {
        product_no: null,
        uom_id: null
      },
      setting: {
        product_no: null,
        product: null,
        uom_id: null,
        uomList: null,
        expired_date: null,
        cost: null,
        vendor_no: null
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      inventoryTypeList: state => state.inventories.inventoryTypeList,
      warehouseList: state => state.warehouses.warehouseList,
      uomList: state => state.uom.uomList,
      vendorList: state => state.vendors.vendorList,
      authUser: state => state.users.authUser,
      productListSelect: state => state.products.productListSelect,
      companyList: state => state.companies.companyList
    }),
    itList () {
      var list = this.inventoryTypeList.filter(d => d.id === 'adjust' || d.id === 'adjust_decrease' || d.id === 'adjust_manufacture_decrease' || d.id === 'adjust_manufacture')
      return list
    },
    totalPurchasingQty () {
      var sum = 0
      var array = this.inventory.purchasing
      for (let i = 0; i < array.length; i++) {
        var arr = array[i].details.filter(d => {
          for (const name in d) {
            if (d[name] !== null) {
              if (d[name].toString().toLowerCase().indexOf(this.searchQueryPurchasing.toLowerCase()) > -1) {
                return d
              }
            }
          }
        })
        if (arr.length > 0) {
          for (let l = 0; l < arr.length; l++) {
            sum += parseFloat(arr[l].qty)
          }
        }
      }
      return sum
    },
    totalPurchasingQtyDone () {
      var sum = 0
      var array = this.inventory.purchasing
      for (let i = 0; i < array.length; i++) {
        var arr = array[i].details.filter(d => {
          for (const name in d) {
            if (d[name] !== null) {
              if (d[name].toString().toLowerCase().indexOf(this.searchQueryPurchasing.toLowerCase()) > -1) {
                return d
              }
            }
          }
        })
        if (arr.length > 0) {
          for (let l = 0; l < arr.length; l++) {
            sum += parseFloat(arr[l].qty_done)
          }
        }
      }
      return sum
    },
    vendorSelect () {
      var loop = []
      var array = this.vendorList
      for (let i = 0; i < array.length; i++) {
        var obj = {
          vendor: array[i].vendor_no + ' - ' + array[i].name,
          meta: {
            code: array[i].vendor_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    productselect: function () {
      var loop = []
      var array = this.productListSelect
      for (var x = 0; x < array.length; x++) {
        var obj = {
          product: array[x].product_no + ' - ' + array[x].product_name,
          meta: {
            code: array[x].product_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    totalDetailCount () {
      return this.inventory.details.length
    },
    totalDetailQtyDemand () {
      var sum = 0
      var array = this.inventory.details
      for (let i = 0; i < array.length; i++) {
        sum += parseInt(array[i].qty_demand)
      }
      return sum
    },
    totalDetailQtyDone () {
      var sum = 0
      var array = this.inventory.details
      for (let i = 0; i < array.length; i++) {
        sum += parseInt(array[i].qty_done)
      }
      return sum
    }
  },
  methods: {
    async setJournalAdjust (reply) {
      var obj = {
        id: this.inventory.id
      }
      var resp = {
        error: false,
        message: null
      }
      var url = null
      if (this.inventory.type_id === 'adjust_decrease') {
        url = inventoryUrl + '/journal-adjust-decrease'
      } else if (this.inventory.type_id === 'adjust') {
        url = inventoryUrl + '/journal-adjust'
      } else if (this.inventory.type_id === 'adjust_manufacture') {
        url = inventoryUrl + '/journal-adjust-manufacture'
      } else if (this.inventory.type_id === 'adjust_manufacture_decrease') {
        url = inventoryUrl + '/journal-adjust-manufacture-decrease'
      }
      console.log(obj)
      console.log(url)
      await axios.post(url, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          resp.error = false
          resp.message = response.data.message
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          if (reply === 'reply') {
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          }
        })
      if (reply) {
        if (resp.error === false) {
          await this.$swal('Success', resp.message, 'success')
        } else {
          await this.$swal('Error', resp.message, 'error')
        }
      }
    },
    async setCOGS () {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = this.inventory.details
      for (let i = 0; i < array.length; i++) {
        var data = {
          date: this.inventory.inventory_date,
          product_no: array[i].product_no,
          type: 'inventory',
          company_no: this.inventory.company_no
        }
        console.log(data)
        await axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log('success sync cogs')
            console.log(response.data.data)
          })
          .catch(error => {
            console.log(error.response)
          })
      }
      await this.$swal('Success', 'Success Sync COGS', 'success')
      this.$Progress.finish()
      this.loader.isLoading = false
    },
    async setCOGSAll (reply) {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = this.inventory.details
      for (let i = 0; i < array.length; i++) {
        var data = {
          date: this.inventory.inventory_date,
          product_no: array[i].product_no,
          type: 'all',
          company_no: this.inventory.company_no
        }
        console.log(data)
        await axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log('success sync cogs')
            console.log(response.data.data)
          })
          .catch(error => {
            console.log(error.response)
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      if (reply === 'reply') {
        await this.$swal('Success', 'Success Sync COGS', 'success')
      }
    },
    select () {
      this.selected = []
      this.currentPage = 1
      var array = this.inventory.details
      if (!this.selectAll) {
        for (const i in array) {
          array[i].receive_finish = true
          array[i].qty_done = array[i].qty_demand
        }
      } else {
        for (const i in array) {
          array[i].receive_finish = false
          array[i].qty_done = 0
        }
      }
    },
    remove: function (index) {
      var detail = this.inventory.details[index]
      console.log(detail)
      if (detail.state === 'create') {
        this.inventory.details.splice(index, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            if (detail.id !== null) {
              axios.delete(inventoryUrl + '/detail/' + detail.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
                .then(response => {
                  this.inventory.details.splice(index, 1)
                })
                .catch(error => {
                  console.log(error.response)
                })
            } else {
              this.inventory.details.splice(index, 1)
            }
          }
        })
      }
    },
    async addLine () {
      var obj = {
        inventory_no: null,
        qty_demand: 1,
        qty_done: 1,
        serial_number: null,
        product_no: this.proNo,
        product_sku: null,
        warehouse_no: null,
        uom_id: null,
        inventory_date: this.inventory.vendor_no,
        branch_no: null,
        company_no: this.inventory.company_no,
        expired_date: null,
        sec_serial_number: null,
        vendor_no: this.inventory.vendor_no,
        canBarcode: false,
        cost: null,
        receive_finish: true,
        uomList: [{
          id: null,
          name: null,
          ratio: '0',
          category: null
        }],
        state: 'create'
      }

      var product = this.productListSelect.find(d => d.product_no === this.proNo)
      console.log('Product: ')
      console.log(product)
      obj.product_no = product.product_no
      obj.product = product.product_name
      obj.canBarcode = product.canBarcode
      var body = {
        product_no: this.proNo
      }
      await axios.post(productUrl + '/uom/list', body, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.data)
          obj.uomList = response.data.data
          obj.uom_id = product.uom_id
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      var dataCosts = {
        date: this.inventory.inventory_date,
        product_no: obj.product_no,
        company_no: null
      }
      console.log(dataCosts)
      await axios.post(productUrl + '/cost/product', dataCosts, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          const data = response.data.data[0]
          console.log(data.cost_amount)
          obj.cost = Math.round(parseFloat(data.cost_amount))
          if (parseFloat(obj.qty_done) === 0) {
            obj.qty_done = 1
          }
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
        })
      this.inventory.details.push(obj)
    },
    async setProduct (index) {
      var detail = this.inventory.details[index]
      var product = this.productListSelect.find(d => d.product_no === detail.product_no)
      console.log('Product: ')
      console.log(product)
      detail.product_no = product.product_no
      detail.product = product.product_name
      detail.canBarcode = product.canBarcode
      var body = {
        product_no: detail.product_no
      }
      await axios.post(productUrl + '/uom/list', body, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.data)
          detail.uomList = response.data.data
          this.inventory.details[index].uom_id = product.uom_id
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      var dataCosts = {
        date: this.inventory.inventory_date,
        product_no: detail.product_no,
        company_no: null
      }
      console.log(dataCosts)
      await axios.post(productUrl + '/cost/product', dataCosts, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          const data = response.data.data[0]
          console.log(data.cost_amount)
          detail.cost = Math.round(parseFloat(data.cost_amount))
          if (parseFloat(detail.qty_done) === 0) {
            detail.qty_done = 1
          }
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
        })
    },
    async saveInventory () {
      this.$Progress.start()
      this.loader.isLoading = true
      var inv = this.inventory
      var detail = []
      var array = this.inventory.details
      var total = 0
      for (let i = 0; i < array.length; i++) {
        if (inv.type_id === 'adjust_decrease' || inv.type_id === 'adjust_manufacture_decrease') {
          total = 0 - array[i].qty_done
        } else {
          total = array[i].qty_done
        }
        var rfinish = parseInt(array[i].qty_demand) === parseInt(array[i].qty_done) ? 'true' : 'false'
        var obj = {
          id: array[i].id,
          inventory_no: array[i].inventory_no,
          serial_number: array[i].serial_number,
          sec_serial_number: array[i].sec_serial_number,
          product_no: array[i].product_no,
          product_sku: array[i].product_sku,
          warehouse_no: array[i].warehouse_no,
          uom_id: array[i].uom_id,
          qty_demand: array[i].qty_demand,
          qty_done: total,
          inventory_date: array[i].inventory_date,
          branch_no: array[i].branch_no,
          expired_date: array[i].expired_date,
          internal_no: array[i].internal_no,
          cost: array[i].cost,
          vendor_no: array[i].vendor_no,
          receive_finish: rfinish
        }
        detail.push(obj)
      }
      var data = {
        id: inv.id,
        inventory_no: inv.inventory_no,
        type_id: inv.type_id,
        inventory_date: inv.inventory_date,
        notes: inv.notes,
        purchasing_no: inv.purchasing_no,
        warehouse_no: inv.warehouse_no,
        company_no: inv.company_no,
        branch_no: inv.branch_no,
        ext_no: inv.ext_no,
        status: 'approve',
        user_id: inv.user_id,
        user_approve: inv.user_approve,
        lock: true,
        ext_no2: inv.ext_no2,
        vendor_no: inv.vendor_no,
        details: detail,
        purchasing: inv.purchasing
      }
      var resp = {
        error: false,
        message: null
      }
      await axios.post(inventoryUrl, data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          resp.error = false
          resp.message = response.data.message
          this.inventory = response.data.data
          this.$emit('setAdjust')
        })
        .catch(error => {
          console.log(error)
          this.$swal('Error', error.message, 'error')
          throw error
        })
      await this.setCOGSAll('no reply')
      await this.setJournalAdjust('no reply')
      if (resp.error === false) {
        await this.$Progress.finish()
        this.loader.isLoading = false
        await this.$swal('Success', resp.message, 'success')
        this.$emit('backSaveClicked')
      }
      this.inventory = {
        id: null,
        inventory_no: null,
        type_id: null,
        inventory_date: new Date().toLocaleString(),
        purchasing_no: null,
        purchasing_id: null,
        warehouse_no: null,
        total_detail: null,
        status: null,
        ext_no: null,
        branch_no: null,
        user_id: null,
        user_approve: null,
        lock: false,
        ext_no2: null,
        vendor_no: null,
        details: []
      }
    }
  }
}
</script>
